import * as EpimsBankDetailStoreActions from './bank-detail.actions';
import * as EpimsBankDetailStoreSelectors from './bank-detail.selectors';
import * as EpimsBankDetailStoreReducer from './bank-detail.reducer';

export { EpimsBankDetailStoreActions, EpimsBankDetailStoreSelectors, EpimsBankDetailStoreReducer };
